export enum ConfigurableReapplicationRuleType {
  TimeSinceDecision = 'TimeSinceDecision',
  MaxNumberOfApplications = 'MaxNumberOfApplications',
}

export enum ImplicitReapplicationRuleType {
  NoApplicationsInProgress,
  NoApplicationsInReview,
  NoReapplication,
}

export type ReapplicationRuleType =
  | ConfigurableReapplicationRuleType
  | ImplicitReapplicationRuleType;

export enum TimeUnit {
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
}

export interface TimeSinceDecisionRule {
  type: ConfigurableReapplicationRuleType.TimeSinceDecision;
  value: number;
  unit: TimeUnit;
}

export interface MaxNumberOfApplicationsRule {
  type: ConfigurableReapplicationRuleType.MaxNumberOfApplications;
  value: number;
}

export interface ImplicitReapplicationRule {
  type: ImplicitReapplicationRuleType;
}

export type ConfigurableReapplicationRule = TimeSinceDecisionRule | MaxNumberOfApplicationsRule;
export type ReapplicationRule = ConfigurableReapplicationRule | ImplicitReapplicationRule;
